import React from "react";
import { SvgIcon } from "@mui/material";

const MotionCautionIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" data-testid="motion-caution-icon">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C12.7294 1 13.4009 1.39707 13.7524 2.03616L23.7524 20.218C24.0932 20.8376 24.0815 21.5911 23.7216 22.1997C23.3617 22.8084 22.7071 23.1818 22 23.1818H2C1.29288 23.1818 0.638317 22.8084 0.27842 22.1997C-0.0814762 21.5911 -0.0932064 20.8376 0.247568 20.218L10.2476 2.03616C10.5991 1.39707 11.2706 1 12 1ZM3.1 19.1818L2 21.1818H4.28254H19.7175H22L20.9 19.1818L13.1413 5.07504L12 3L10.8587 5.07504L3.1 19.1818Z"
      />
      <path d="M2 21.1818L12 3L22 21.1818H2Z" fill="white" />
      <path d="M12.6 15.4375C12.7334 13.8625 13.0667 9.46563 13.0667 8.21875V7.5625H11.0667V8.21875C11.0667 9.46563 11.3334 13.8625 11.5334 15.4375H12.6Z" />
      <ellipse cx="12" cy="18.0625" rx="1.33333" ry="1.3125" />
    </SvgIcon>
  );
};

export default MotionCautionIcon;
